<div *ngIf="form" [formGroup]="form">
  <div class="cord-label">
    <h3 class="label">{{ (form.controls.source.value === RosterUploadFileType.External ? 'SELECTED_STUDENTS' : 'SELECT_STUDENTS') | translate }}</h3>
  </div>
  <!-- Upload type switcher -->
  <ng-container *ngIf="form.controls.source.value !== RosterUploadFileType.External">
    <div *appHasAnyAuthority="authority.Admin" class="form-group d-flex">
    <div class="custom-control custom-radio mr-4">
      <input
        type="radio"
        id="manualUpload"
        name="students"
        class="custom-control-input"
        [checked]="form.controls.source.value === uploadFileTypes.Manual"
        (change)="onUploadTypeChange(uploadFileTypes.Manual)"
      />
      <label class="custom-control-label custom-control-label-sm" for="manualUpload">{{
        'MANUAL_UPLOAD' | translate
      }}</label>
    </div>
    <div class="custom-control custom-radio">
      <input
        type="radio"
        id="serverUpload"
        name="students"
        class="custom-control-input"
        [checked]="form.controls.source.value === uploadFileTypes.Automatic"
        (change)="onUploadTypeChange(uploadFileTypes.Automatic)"
      />
      <label class="custom-control-label custom-control-label-sm" for="serverUpload">{{
        'SERVER_UPLOAD' | translate
      }}</label>
    </div>
    <app-form-error [control]="form.controls.source"></app-form-error>
    </div>
  </ng-container>

  <!-- Automatic upload -->
  <div *appHasAnyAuthority="authority.Admin" [hidden]="form.controls.source.value !== uploadFileTypes.Automatic">
    <div class="form-group" appParentValidator [control]="form.controls.file">
      <div class="app-input">
        <label for="automaticUpload"> {{ 'FILE_NAME' | translate }}</label>
        <app-auto-complete
          (selectedItemChange)="onSelectChange($event)"
          (searchChange)="onSearchChange($event)"
          [selectedItem]="form.controls.file.value"
          [minTermLength]="1"
          [itemsData]="files"
        ></app-auto-complete>
      </div>
      <app-form-error [control]="form.controls.file"></app-form-error>
    </div>

    <!-- List of selected items -->
    <ul class="list-group list-group-remove" *ngIf="form.controls.items.value && form.controls.items.value.length > 0">
      <li *ngFor="let item of getSortedItems(form.controls.items.value)" class="list-group-item">
        <b class="mr-3">{{ item?.extraLabels?.firstLabel }} {{ item?.extraLabels?.secondLabel }}</b>
        {{ item?.extraLabels?.thirdLabel }}
        <span class="ml-auto">
          <span class="round-btn round-btn-xs list-group-action ml-1" (click)="onRemove(item)" [appTooltip]="'INACTIVE' | translate"
            ><i class="ftmi-cross"></i
          ></span>
        </span>
      </li>
    </ul>
    <div *ngIf="!form.controls.items.value || form.controls.items.value.length === 0" class="empty-list-message small">
      {{ 'ROSTER_LIST_EMPTY_MESSAGE' | translate }}
    </div>
  </div>

  <!-- Manual upload -->
  <div [hidden]="form.controls.source.value !== uploadFileTypes.Manual">
    <app-roster-manual-upload [form]="form"> </app-roster-manual-upload>
  </div>

  <div *ngIf="form.controls.source.value === RosterUploadFileType.External">
    <ul class="list-group list-group-remove" *ngIf="form.controls.items.value && form.controls.items.value.length > 0">
      <li *ngFor="let item of form.controls.items.value" class="list-group-item">
        <b class="mr-3">{{ item?.extraLabels?.firstLabel }} {{ item?.extraLabels?.secondLabel }}</b>
        {{ item?.extraLabels?.thirdLabel }}
        <span class="ml-auto" *ngIf="form.controls.source.value !== RosterUploadFileType.External">
          <span class="round-btn round-btn-xs list-group-action ml-1" (click)="onRemove(item)" [appTooltip]="'INACTIVE' | translate"
            ><i class="ftmi-cross"></i
          ></span>
        </span>
      </li>
    </ul>
    <div *ngIf="form.controls.items.value === null || form.controls.items.value.length === 0" class="empty-list-message small">
      {{ 'ROSTER_EXTERNAL_EMPTY_MESSAGE' | translate }}
    </div>
  </div>
</div>
